<template>
    <div class="flex justify-start gap-4">
      <!-- :style="{ 'background-image': previewImage ? `url(${previewImage})` : 'url()' }" -->
      <div
        class="imagePreviewWrapper w-20 h-20 rounded-lg cursor-pointer"
        :style="{
          'background-image': imageUrl.length > 0
            ? `url(${imageUrl})`
            : previewImage
            ? `url(${previewImage})`
            : '',
              border: '5px solid #E0E0E0'
        }"
        @click="selectImage"
      >
        <p
            :style="{ color: '#E0E0E0' }"
            class="font-bold text-gray-400 mx-auto text-center text-xl mt-3"
            v-if="imageUrl.length == 0 && previewImage "
        >
                +
            </p>
      </div>

      <p v-if="!saveClosed" @click="selectImage" :style="{ color: '#FCC210' }" class="mt-4 cursor-pointer">Upload</p>
      <p v-if="!saveClosedOrg" @click="selectImage" :style="{ color: '#FCC210' }" class="mt-4 cursor-pointer">Upload</p>

      <div v-if="isUploadingImage" class="d-flex justify-content-center py-2">
        <saving-loader :icon-color="'#0253B3'" />
      </div>
      <input
        ref="fileInput"
        type="file"
        @input="pickFile"
        accept="image/*"
        class="file-input"
      />
    </div>
  </template>
  
  <script>
  import SavingLoader from "@/components/UI/ButtonSavingLoader";
  
  export default {
    props: {
      imageUrl: {
        required: false,
        default: "",
      },
      isUploadingImage: {
        required: false,
        default: false,
        type: Boolean,
      },
      saveClosed: {
        required: false,
        default: false,
        type: Boolean,
      },
      saveClosedOrg: {
        required: false,
        default: false,
        type: Boolean,
      },
    },
    components: {
      SavingLoader,
    },
    data() {
      return {
        previewImage: null,
      };
    },
    methods: {
      selectImage() {
        this.$refs.fileInput.click();
      },
      removeImage() {
        this.previewImage = null;
        this.$emit("remove-image");
      },
      pickFile() {
        let input = this.$refs.fileInput;
        let file = input.files;
        if (file && file[0].size > 1048576) {
          this.generateToast(
            "Selected image size is too large. Please upload an image smaller than 1MB!",
            "error"
          );
        } else {
          if (file && file[0]) {
            let reader = new FileReader();
            reader.onload = (e) => {
              this.previewImage = e.target.result;
            };
            reader.readAsDataURL(file[0]);
            this.$emit("input", file[0]);
          }
        }
      },
    },
    mounted(){
      console.log(this.imageUrl, "image ri")
    }
  };
  </script>
  
  <style scoped lang="scss">
  .imagePreviewWrapper {
    position: relative;
    display: block;
    cursor: pointer;
    background-image: url("../../../assets/images/settings/blank-profile-picture.png");
    // margin: 0 auto;
    background-size: cover;
    background-position: center center;
  }
  .img-upload-icon {
    position: absolute;
    right: 0;
    top: 5rem;
  }
  .file-input {
    display: none;
  }
  </style>
  